import { IconComponent } from '../icon.types';

export const SteamIcon: IconComponent = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_388_582)">
      <path
        d="M11.9793 0.000183105C5.66437 0.000183105 0.49125 4.85681 0 11.0283L6.44287 13.6853C7.00546 13.3004 7.6736 13.0946 8.35781 13.0954C8.42175 13.0954 8.48494 13.0972 8.54719 13.1006L11.4128 8.95768V8.89967C11.4128 6.40678 13.4462 4.37812 15.9458 4.37812C18.4454 4.37812 20.4788 6.40678 20.4788 8.89967C20.4788 11.3925 18.4454 13.422 15.9458 13.422C15.9112 13.422 15.8774 13.4211 15.8429 13.4203L11.7561 16.3278C11.7587 16.3817 11.7604 16.4355 11.7604 16.4885C11.7604 18.3607 10.2338 19.8833 8.35781 19.8833C6.711 19.8833 5.33316 18.7104 5.02181 17.1579L0.413437 15.2574C1.84059 20.2902 6.47653 23.9799 11.9793 23.9799C18.6185 23.9799 24 18.6113 24 11.9901C24 5.36812 18.6185 0.000183105 11.9793 0.000183105ZM7.533 18.1928L6.05653 17.5842C6.31781 18.1278 6.771 18.5826 7.37213 18.8324C8.67122 19.3726 10.1693 18.7579 10.7108 17.461C10.9729 16.8374 10.9745 16.1366 10.7151 15.5119C10.4556 14.8827 9.96516 14.392 9.33637 14.1304C8.71106 13.8714 8.04159 13.8807 7.45341 14.1022L8.97919 14.7314C9.9375 15.1298 10.3907 16.2274 9.99113 17.1832C9.59241 18.139 8.49131 18.5912 7.533 18.1928ZM18.9665 8.89967C18.9665 7.2387 17.6111 5.88629 15.9461 5.88629C14.2803 5.88629 12.9249 7.2387 12.9249 8.89967C12.9249 10.5607 14.2803 11.9123 15.9461 11.9123C17.6111 11.9123 18.9665 10.5607 18.9665 8.89967ZM13.6818 8.89458C13.6818 7.64475 14.698 6.63176 15.9505 6.63176C17.2038 6.63176 18.22 7.64475 18.22 8.89458C18.22 10.1444 17.2038 11.1575 15.9504 11.1575C14.698 11.1575 13.6817 10.1444 13.6817 8.89467L13.6818 8.89458Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_388_582">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
